module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/1-77a6df78fa672a2b86070f9c121cb3fd.jpg";